export default __webpack_public_path__ + "414ed008092cd51d5fdd5d10e473ce4b.png";